export const SportTargetIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M13.5901 6.15433C13.9749 6.90125 14.192 7.75001 14.192 8.64816C14.192 11.6729 11.7286 14.1235 8.68806 14.1235C5.64753 14.1235 3.18408 11.6729 3.18408 8.64816C3.18408 5.62347 5.65063 3.17285 8.68806 3.17285C9.55678 3.17285 10.379 3.37347 11.1081 3.72841"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M11.7441 7.09582C11.983 7.56187 12.1195 8.08964 12.1195 8.64829C12.1195 10.5341 10.5837 12.0588 8.69117 12.0588C6.79859 12.0588 5.26282 10.531 5.26282 8.64829C5.26282 6.76557 6.79859 5.23779 8.69117 5.23779C9.23412 5.23779 9.74604 5.36125 10.199 5.58347"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M15.3028 4.74383C15.9853 5.8858 16.3794 7.22222 16.3794 8.64815C16.3794 12.8735 12.9355 16.2963 8.69117 16.2963C4.44684 16.2963 0.999878 12.8735 0.999878 8.64815C0.999878 4.42284 4.44374 1 8.68807 1C9.91979 1 11.0864 1.28704 12.1164 1.80247"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M8.68799 8.64787L11.7657 5.22503L13.7669 4.8238L15.7681 3.17256L13.8879 2.81145L13.3729 1.27441L11.9054 3.29293L11.7657 5.22503"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
)
